export default "__VITE_ASSET__B$BjDrBD__"